import React, { Component } from 'react';
import { Router, Route, Switch, Redirect, withRouter } from 'react-router-dom';
import { hot } from 'react-hot-loader';

import BusinessTypeSection from './businessTypeSection';
import InitialQuestionsSection from './initialQuestionsSection';
import PersonalInformationSection from './personalInformationSection';
import UsernamePasswordSection from './usernamePasswordSection';
import AccountDetailsSection from './accountDetailsSection';
import AdditionalProductsSection from './additionalProductsSection';
import ReviewSections from './reviewSections';
import ImportantInformationSection from './importantInformationSection';
import EnterAuthSection from './enterAuthSection';
import OpenBusinessAccountSection from './openBusinessAccountSection';
import AltBusinessAccountSection from './altBusinessAccountSection';
import DeclineSection from './declineSection';
import OfferSection from './offerSection';
import EnterLinkCodeSection from './enterLinkCodeSection';
import CheckIdentitySection from './checkIdentitySection';
import SetupInProgressError from './setupInProgressError';
import TechnicalError from './common/technicalError';
import AppBootstrapComponent from './appBootstrap';
import PropTypes from '../types';
import PendingStatementsSection from './pendingStatementsSection';
import CreditCheckDeferredSection from './creditCheckDeferredSection';
import DeferredSection from './deferredSection';
import PersonDetailsSection from './personDetailsSection';
import IDVQuestionsContainer from './ivdQuestions';
import PrimaryApplicantWaiting from '../routes/primaryApplicantWaiting';
import SecondaryApplicantWaiting from '../routes/secondaryApplicantWaiting';
import ResumeDashBoardSection from './ResumePortal/ResumeDashBoardSection';
import ApplicationSubmissionSection from '../routes/applicationSubmission';

import {
  ROUTE_INITIAL_QUESTION_PAGE,
  ROUTE_PERSONAL_INFO_PAGE,
  ROUTE_BUSINESS_TYPE_PAGE,
  ROUTE_USERNAME_PASSWORD_PAGE,
  ROUTE_ACCOUNT_DETAILS_PAGE,
  ROUTE_ADDITIONAL_PRODUCT_PAGE,
  ROUTE_REVIEW_PAGE,
  ROUTE_INFO_SECTION,
  ROUTE_TECH_ERROR,
  SET_UP_IN_PROGRESS_ERROR,
  ROUTE_APP_BOOTSTRAP,
  DECLINE,
  ROUTE_OPEN_BUSINESS_ACCOUNT_PAGE,
  ROUTE_ALT_BUSINESS_ACCOUNT_PAGE,
  LETTER_CODE,
  OFFER_PAGE,
  ROUTE_PENDING_STATEMENTS_PAGE,
  ROUTE_CREDIT_CHECK_REFERRED_NO_MATCH_PAGE,
  ROUTE_DEFERRED_PAGE,
  ROUTE_CHECK_IDENTITY_PAGE,
  ROUTE_IDV_QUESTION_PAGE,
  ROUTE_PENDING_STATEMENTS_FAIL_PAGE,
  ROUTE_BUSINESS_MANDATE_PAGE,
  ROUTE_SIGNATORIES_AND_SHAREHOLDERS_PAGE,
  ROUTE_SIGNIFICANT_PEOPLE_PAGE,
  ROUTE_PERSONAL_DETAILS_PAGE,
  ROUTE_ENTER_LINK_CODE,
  ROUTE_TO_INCORRECT_LINK_CODE,
  ROUTE_PRIMARY_APPLICANT_WAITING,
  ROUTE_SECONDARY_APPLICANT_WAITING,
  ROUTE_SECURITY_CHECKS_PAGE,
  ROUTE_ALMOST_THERE_PAGE,
  ROUTE_SWITCH_BUSINESS_PAGE,
  ROUTE_OLD_ACCOUNT_DETAILS_PAGE,
  ROUTE_OLD_SIGNATORIES_PAGE,
  ROUTE_OLD_ADD_SIGNATORY_PAGE,
  ROUTE_SWITCH_DATE_PAGE,
  ROUTE_APPLICATION_COMPLETE_PAGE,
  ROUTE_TO_IDV_CHALLENGE_ERROR,
  ROUTE_BEGIN_YOUR_APPLICATION_PAGE,
  ROUTE_ABOUT_YOUR_APPLICATION_PAGE,
  ROUTE_RESUME_PAGE,
  ROUTE_APPLICATION_SUBMISSION_PAGE,
  ROUTE_INFORMATIVE_PAGE,
  ROUTE_DOCUMENT_VERSION_PAGE
} from '../utils/constants';
import PendingStatementsFailSection from './pendingStatementFail';
import BusinessMandateSection from './businessMandateSection';
import SignatoriesAndShareholdersSection from './signatoriesAndShareholdersSection';
import SignificantPeopleSection from './significantPeopleSection';
import IncorrectLinkCodeSection from './incorrectLinkCodeSection';
import SecurityChecksSection from './securityChecksSection';
import IDVChallengeError from './idvChallengeError';

import AlmostThereSection from './almostThereSection';
import SwitchBusinessSection from './switchBusinessSection';
import OldAccountDetailsSection from './oldAccountDetailsSection';
import OldSignatoriesSection from './oldSignatoriesSection';
import OldAddSignatorySection from './oldAddSignatorySection';
import SwitchDateSection from './switchDateSection';
import ApplicationCompleteSection from './applicationCompleteSection';
import BeginApplicationSection from './beginApplicationSection';
import AboutYourApplicationSection from './aboutYourApplicationSection';
import InformativeScreen from './informativeScreen';

import DocumentVersionPage from './documentVersionPage';

class ScrollToTop extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return this.props.children;
  }
}
const RouterScrollToTop = withRouter(ScrollToTop);

const Routes = ({ history }) => (
  <Router history={history}>
    <RouterScrollToTop>
      <Switch>
        <Redirect exact from="/" to={ROUTE_APP_BOOTSTRAP} />
        <Route path={ROUTE_APP_BOOTSTRAP} component={AppBootstrapComponent} />
        <Route path={ROUTE_ENTER_LINK_CODE} component={EnterLinkCodeSection} />
        <Route path={ROUTE_IDV_QUESTION_PAGE} component={IDVQuestionsContainer} />
        <Route path={ROUTE_INITIAL_QUESTION_PAGE} component={InitialQuestionsSection} />
        <Route path={ROUTE_PERSONAL_INFO_PAGE} component={PersonalInformationSection} />
        <Route path={ROUTE_BUSINESS_TYPE_PAGE} component={BusinessTypeSection} />
        <Route path={ROUTE_USERNAME_PASSWORD_PAGE} component={UsernamePasswordSection} />
        <Route path={ROUTE_ACCOUNT_DETAILS_PAGE} component={AccountDetailsSection} />
        <Route path={ROUTE_ADDITIONAL_PRODUCT_PAGE} component={AdditionalProductsSection} />
        <Route
          path={ROUTE_SIGNATORIES_AND_SHAREHOLDERS_PAGE}
          component={SignatoriesAndShareholdersSection}
        />
        <Route path={ROUTE_SIGNIFICANT_PEOPLE_PAGE} component={SignificantPeopleSection} />
        <Route path={ROUTE_BUSINESS_MANDATE_PAGE} component={BusinessMandateSection} />
        <Route path={ROUTE_REVIEW_PAGE} component={ReviewSections} />
        <Route path={ROUTE_INFO_SECTION} component={ImportantInformationSection} />
        <Route path={ROUTE_SECURITY_CHECKS_PAGE} component={SecurityChecksSection} />
        <Route path={ROUTE_CHECK_IDENTITY_PAGE} component={CheckIdentitySection} />
        <Route path={LETTER_CODE} component={EnterAuthSection} />
        <Route path={ROUTE_OPEN_BUSINESS_ACCOUNT_PAGE} component={OpenBusinessAccountSection} />
        <Route path={ROUTE_ALT_BUSINESS_ACCOUNT_PAGE} component={AltBusinessAccountSection} />
        <Route path={DECLINE} component={DeclineSection} />
        <Route path={OFFER_PAGE} component={OfferSection} />
        <Route path={ROUTE_TECH_ERROR} component={TechnicalError} />
        <Route path={SET_UP_IN_PROGRESS_ERROR} component={SetupInProgressError} />
        <Route path={ROUTE_PENDING_STATEMENTS_PAGE} component={PendingStatementsSection} />
        <Route path={ROUTE_PENDING_STATEMENTS_FAIL_PAGE} component={PendingStatementsFailSection} />
        <Route
          path={ROUTE_CREDIT_CHECK_REFERRED_NO_MATCH_PAGE}
          component={CreditCheckDeferredSection}
        />
        <Route path={ROUTE_DEFERRED_PAGE} component={DeferredSection} />
        <Route path={ROUTE_PERSONAL_DETAILS_PAGE} component={PersonDetailsSection} />
        <Route path={ROUTE_PRIMARY_APPLICANT_WAITING} component={PrimaryApplicantWaiting} />
        <Route path={ROUTE_SECONDARY_APPLICANT_WAITING} component={SecondaryApplicantWaiting} />
        <Route path={ROUTE_TO_INCORRECT_LINK_CODE} component={IncorrectLinkCodeSection} />

        <Route path={ROUTE_ALMOST_THERE_PAGE} component={AlmostThereSection} />
        <Route path={ROUTE_SWITCH_BUSINESS_PAGE} component={SwitchBusinessSection} />
        <Route path={ROUTE_OLD_ACCOUNT_DETAILS_PAGE} component={OldAccountDetailsSection} />
        <Route path={ROUTE_OLD_SIGNATORIES_PAGE} component={OldSignatoriesSection} />
        <Route path={ROUTE_OLD_ADD_SIGNATORY_PAGE} component={OldAddSignatorySection} />
        <Route path={ROUTE_SWITCH_DATE_PAGE} component={SwitchDateSection} />
        <Route path={ROUTE_APPLICATION_COMPLETE_PAGE} component={ApplicationCompleteSection} />
        <Route path={ROUTE_TO_IDV_CHALLENGE_ERROR} component={IDVChallengeError} />
        <Route path={ROUTE_BEGIN_YOUR_APPLICATION_PAGE} component={BeginApplicationSection} />
        <Route path={ROUTE_ABOUT_YOUR_APPLICATION_PAGE} component={AboutYourApplicationSection} />
        <Route path={ROUTE_RESUME_PAGE} component={ResumeDashBoardSection} />
        <Route path={ROUTE_APPLICATION_SUBMISSION_PAGE} component={ApplicationSubmissionSection} />
        <Route path={ROUTE_INFORMATIVE_PAGE} component={InformativeScreen} />

        <Route path={ROUTE_DOCUMENT_VERSION_PAGE} component={DocumentVersionPage} />
      </Switch>
    </RouterScrollToTop>
  </Router>
);

Routes.propTypes = {
  history: PropTypes.shape({}).isRequired
};
export default hot(module)(Routes);
